import React, {useState, useEffect} from "react"
import GenericModal from "@irati/ui/src/GenericModal"

import authentication from "@irati/auth"
import OnboardingService from "@irati/onboarding/services/onboarding"
import OnboardingStep from "@irati/onboarding/enums/Step"
import recognitionTracking from "@irati-tracking/recognition/recognition"

import History, {useAppRouteContext} from "@irati/utils/history"
import {useRecognitionNudge} from "@irati/recognition/hooks"
import {withRouter} from "react-router-dom"
import {RecognitionRoutes} from "../../enums/Routes"
import Content from "./Content"

const LEGACY_ONBOARDING_STORAGE_KEY = "hideOnboarding"

const Onboarding = withRouter(({location}) => {
  const [showModal, setShowModal] = useState(false)

  const context = useAppRouteContext()
  const {allowNudge, dismissNudge} = useRecognitionNudge()

  useEffect(() => {
    /** avoid calling old state callbacks after promise resolves */
    let ignore = false

    // Moved from LocalStorage -> graph (Feb-2020), check kept to avoid double tours
    const showModalLegacyCheck = localStorage.getItem(LEGACY_ONBOARDING_STORAGE_KEY)

    if (!authentication.isUserGhost()) {
      OnboardingService.get(authentication.user().uuid || "").then((res) => {
        if (ignore) return

        const hasOnboarded = !!res.userProgress?.find(({step}) => {
          return step === OnboardingStep.HAS_COMPLETED_FIRST_RECOGNITION_TOUR
        })

        // If the service thinks the user should see the tour but they have the LocalStorage, fire an update
        if (!hasOnboarded && showModalLegacyCheck) {
          completeTour()
        } else if (!hasOnboarded) {
          // If a nudge has been sent, onboarding will take precedence, we don't want the nudge as well
          dismissNudge()

          setShowModal(!location.pathname.includes(RecognitionRoutes.CREATE_RECOGNITION))
        } else {
          allowNudge((nudge) => {
            if (nudge && !location.pathname.includes(RecognitionRoutes.CREATE_RECOGNITION)) {
              History.push(
                {pathname: RecognitionRoutes.CREATE_RECOGNITION, state: {isFirstRecognition: true, contentCardTrigger: nudge}},
                context
              )
            }
          })
        }
      })
    }
    return () => {
      ignore = true
    }
  }, [dismissNudge, allowNudge, context, location.pathname])

  useEffect(() => {
    if (showModal) {
      recognitionTracking.viewOnboarding()
    }
  }, [showModal])

  const completeTour = () => OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_COMPLETED_FIRST_RECOGNITION_TOUR)

  const hide = () => {
    recognitionTracking.dismissOnboarding()
    closeModal()
  }

  const closeModal = () => {
    completeTour()
    setShowModal(false)
  }

  return (
    <GenericModal show={showModal} onHide={hide} hideActions>
      <Content closeModal={closeModal} />
    </GenericModal>
  )
})

export default Onboarding
